module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Закрыть","flags":["TRACK"],"track":"Close"}}